'use client';

import type { ReactNode } from 'react';
import { Text } from '@skin-seoul/design-system';
import type { SafeLinkProps } from '@/components/ui/SafeLink';
import { SafeLink } from '@/components/ui/SafeLink';
import { CLASSNAME } from '@skin-seoul/service';
type TextStyle = Parameters<typeof Text>[0]['textStyle'];
type FontWeight = Parameters<typeof Text>[0]['fontWeight'];
export const MenuItem = ({
  children,
  textStyle = 'paragraph.small',
  fontWeight = 'regular',
  ...rest
}: {
  children: ReactNode;
  textStyle?: TextStyle;
  fontWeight?: FontWeight;
} & SafeLinkProps) => {
  return <Text _hover={{
    color: 'neutral.500'
  }} asChild color="neutral.700" textStyle={textStyle} fontWeight={fontWeight} transition="color 0.3s" data-sentry-element="Text" data-sentry-component="MenuItem" data-sentry-source-file="MenuItem.tsx">
      <SafeLink {...rest} textDecoration="none" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="SafeLink" data-sentry-source-file="MenuItem.tsx">
        {children}
      </SafeLink>
    </Text>;
};